import { NavLink, Navigate, Route, Routes } from "react-router-dom";
import { useList } from "@/hooks/crud";
import Dashboard from "@/views/Dashboard";
import TracksList from "@/views/TracksList";
import TrackDetail from "@/views/TrackDetail";
import ArtistsList from "@/views/ArtistsList";
import ProjectsList from "@/views/ProjectsList";

function NavCount({ table }: { table: Parameters<typeof useList>[0] }) {
  const { data } = useList(table, "select=id&limit=1");
  return <span className="count">{data ? data.total : ""}</span>;
}

function Sidebar() {
  const link = ({ isActive }: { isActive: boolean }) =>
    "nav-link" + (isActive ? " active" : "");
  return (
    <aside className="sidebar">
      <div className="brand">
        <span className="spark" />
        EPR Master Control
      </div>

      <div className="nav-section">Pipeline</div>
      <NavLink to="/" end className={link}>
        <span>Dashboard</span>
      </NavLink>
      <NavLink to="/tracks" className={link}>
        <span>Tracks</span>
        <NavCount table="tracks" />
      </NavLink>

      <div className="nav-section">Catalog</div>
      <NavLink to="/artists" className={link}>
        <span>Artists</span>
        <NavCount table="artists" />
      </NavLink>
      <NavLink to="/projects" className={link}>
        <span>Projects</span>
        <NavCount table="projects" />
      </NavLink>
    </aside>
  );
}

export default function App() {
  return (
    <div className="app">
      <Sidebar />
      <main className="main">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/tracks" element={<TracksList />} />
          <Route path="/tracks/:id" element={<TrackDetail />} />
          <Route path="/artists" element={<ArtistsList />} />
          <Route path="/projects" element={<ProjectsList />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}
